export const CyberKey = 'your-secret-key';
export const ApiKey =
  'BEkn9NPM3c10QR9rHTuygevehzIPLwhxwSjgHqT0Hp1w7qsCWVoTsy33qf1bXUi9ngkgWhpgaHCA-TN8919Jyw';
